import { FC, ReactNode } from "react";

const ContentTitle: FC<{ children: ReactNode }> = ({ children }) => <div className="content-block-title">{children}</div>;

export default ContentTitle;
